import React, { useEffect, useState } from 'react';
import i18n from 'i18n-js';
import { debounce } from 'lodash';
import ActionsTable from './Table';
import { Card } from 'components/UI';
import { Box, Grid } from '@material-ui/core';
import { CardStyles } from './Actions.styled';
import ActionsTotalsCards from './TotalsCards';
import { useDispatch, useSelector } from 'react-redux';
import { DashboardActions } from 'state/modules/dashboard';

const Actions = () => {
  const dispatch = useDispatch();
  const CardClasses = CardStyles();
  const [onRefresh, setRefresh] = useState(false);

  const {
    actions: { list, pagination },
    fetchingActions,
  } = useSelector((state) => state.dashboard);

  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    actions: ['SCHEDULEDELIVERY', 'MARKASDELIVERED', 'NEEDSAPPROVAL', 'MARKASRETURNED'],
  });

  const getQualsActions = () => {
    dispatch(DashboardActions.fetchQualsActions(params));
  };

  const handlePageChange = (page) => {
    const newParams = { page: page, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  /**
   * Handle per rows (limit) change on table
   * @param {number} limit New limit value
   */
  const handlePerRowsChange = async (limit) => {
    const newParams = { page: 1, limit: limit };
    setParams({ ...params, ...newParams });
  };

  const handleChangeFilter = debounce((filters) => {
    setParams({ ...filters });
  }, 500);

  // sort filter
  const handleSort = ({ column, sortDirection }) => {
    const newParams = {
      ...params,
      page: pagination?.currentPage,
      sort_field: column.selector,
      sort_desc: sortDirection === 'desc' ? true : false,
    };
    setParams(newParams);
  };

  // filter quals actions list
  const search = (name, value) => {
    const filters = {
      ...params,
      page: 1,
      // validate if value is an object
      [name]: value,
    };
    // remove empty fields
    Object.keys(filters).forEach(
      (key) => !filters[key] && filters[key] !== false && key !== 'keyword' && delete filters[key]
    );
    handleChangeFilter({ ...filters });
  };

  const handleRefresh = () => {
    setRefresh(true);
    getQualsActions();
  };

  useEffect(() => {
    getQualsActions();
  }, [params]); // eslint-disable-line

  return (
    <Card
      enableCollapse
      title={i18n.t('dashboard.actions.title')}
      contentRootClasses={CardClasses}
      headerActionType="vertical"
      loading={fetchingActions}
      onRefresh={handleRefresh}
    >
      <Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
        <Grid item xs={12}>
          <Box px={4} pt={2}>
            <ActionsTotalsCards
              onRefresh={onRefresh}
              handleRefresh={() => setRefresh(false)}
              parameters={{
                actions: params.actions || undefined,
                source_id: params.source_id || undefined,
                source_type: params.source_type || undefined,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <ActionsTable
            list={list}
            search={search}
            params={params}
            handleSort={handleSort}
            pagination={pagination}
            loading={fetchingActions}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default Actions;
